import React, { Fragment } from 'react';

export const siteNavData = [
  {
    label: 'Soluções',
    items: [
      {
        title: 'Força de vendas',
        description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
        icon: 'bar_chart',
        link: '/forca-vendas/',
      },
      {
        title: 'E-commerce B2B',
        description: 'Venda 24h por dia com a loja online de empresas para empresas',
        icon: 'shopping_cart',
        link: '/e-commerce-b2b',
      },
      {
        type: 'separator',
        label: 'Outras Soluções',
      },
      {
        title: 'CRM',
        description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
        icon: 'filter_alt',
        link: '/crm-de-vendas',
      },
      {
        title: 'Mercos Pay',
        description: 'Receba pagamentos por pix, boleto e cartões de crédito',
        icon: 'credit_card',
        link: '/mercos-pay',
      },
      {
        title: 'Videochamada',
        description: 'Venda por vídeo com experiência de visita presencial',
        icon: 'videocam',
        link: '/videochamada',
      },
    ],
  },
  {
    label: 'Segmentos',
    items: [
      {
        title: 'Indústrias',
        description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
        icon: 'factory',
        link: '/sistema-para-industria/',
      },
      {
        title: 'Distribuidoras',
        description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
        icon: 'home_work',
        link: '/sistema-distribuidora/',
      },
      {
        title: 'Representantes',
        description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
        icon: 'work',
        link: '/sistema-representante/',
      },
    ],
  },
  {
    label: 'Planos e preços',
    items: [
      {
        title: (
          <Fragment>
            Planos para <strong>Indústrias e distribuidoras</strong>
          </Fragment>
        ),
        description: '',
        icon: 'factory',
        link: '/planos-e-precos/industrias-e-distribuidoras/',
      },
      {
        title: (
          <Fragment>
            Planos para <strong>Representantes</strong>
          </Fragment>
        ),
        description: '',
        icon: 'work',
        link: '/planos-e-precos/representantes/',
      },
    ],
  },
  {
    label: 'Integrações',
    items: [
      {
        title: 'ERPs integrados',
        description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
        icon: 'device_hub',
        link: '/integracao-erp',
      },
      {
        title: 'Seja Parceiro',
        description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
        icon: 'people',
        link: '/parceiros',
      },
    ],
  },
  {
    label: 'Recursos',
    grid: true,
    items: [
      {
        title: 'Aplicativo de vendas',
        description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
        icon: 'smartphone',
        link: '/recursos/aplicativo-vendas-externas/',
      },
      {
        title: 'Mercos IA',
        description: 'Inteligência Artificial na palma da sua mão',
        icon: 'auto_awesome',
        link: '/recursos/mercos-ia/',
      },
      {
        title: 'Indicadores de vendas',
        description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
        icon: 'show_chart',
        link: '/recursos/indicadores-performance/',
      },
      {
        title: 'Materiais ricos',
        description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
        icon: 'menu_book',
        link: '/materiais/',
      },
      {
        title: 'Políticas comerciais',
        description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
        icon: 'flag',
        link: '/recursos/politica-comercial-vendas/',
      },
      {
        title: 'Cases',
        description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
        icon: 'rocket_launch',
        link: 'https://mercos.com/cases/',
      },
    ],
  },
];



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/siteNavData.jsx